/* eslint-disable prefer-const */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useRef, useState } from 'react';
import { Alert, Box, Button, Grid, Icon, IconButton, LinearProgress, Paper, Snackbar, SnackbarCloseReason, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { VTextField, VForm, useVForm, VTextFieldData, BasicSelect, BasicAutoComplete, AutoCompleteTransportadora, AutoCompleteVeiculos, AutoCompleteParceiro, IVFormErrors, BasicSelectNumber, VFieldMoneynumber, VTextFieldNumber, VFieldMoneyNumber4dn } from '../../../shared/forms';
import { FerramentasDeDetalheNfe, TelaBloqueioSalvando } from '../../../shared/components';
import { useBloqueioSalvamento } from '../../../shared/hooks';
import dayjs from 'dayjs';
import { LayoutBaseDePaginaNfe } from '../../../shared/layouts';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { NfeService } from '../../../shared/services/api/Financeiro/fiscal';
import { DialoNfe } from './DialogNfe';
import { useTheme, alpha } from '@mui/material/styles';
import { v4 as uuidv4 } from 'uuid';
import { Environment } from '../../../shared/environment';
import { DialoCancelar } from './DialogCancelar';
import { DialogCartaCorrecao } from './DialogCartaCorrecao';
import { DialogVerificarNfe } from './DialogVerificarNfe';
import { IProblemaNfe, verificarNotaFiscalAntesDeEnviar } from '../../../shared/utils/validarNotaFiscal';
import { getAuth } from '../../../GlobalDecode';
import { DetalheDeProduto } from '../../Estoque/produtos/DetalheDeProduto';

interface IFormData {
  nfe: number;
  indpag: number;
  natureza: string;
  dhemi: string;
  datasaida?: string;
  tpemis: number;
  nfecpl: string;
  volumequantidade: number;
  volumemarca: string;
  volesp: string;
  volumepesobruto: number;
  volumepesoliquido: number;
  numerovolume: string;
  obscomplementar: string;
  tpag: string;
  finnfe: number;
  vbc: number;
  vicms: number;
  vprod: number;
  vfrete: number;
  vseg: number;
  vdesc: number;
  vipi: number;
  vconfins: number;
  vpis: number;
  vnfe: number;
  vst: number;
  vbcst: number;
  voutro: number;
  tpnfe: number;
  modfrete: number;
  idparceiro: string;
  idtransportadora?: string | null;
  idveiculo?: string | null;
  status: number;
}

interface IItensNFe {
  iditens: string;
  idprodutos: string;
  vfrete: number;
  voutros: number;
  vicmsst: number;
  ean: string;
  descricao: string;
  ncm: string;
  origem: number;
  cfop: number | null;
  un: string;
  untrib: string;
  qtd: number;
  qtdtrib: number;
  preco: number;
  precotrib: number;
  cst: string;
  vbc: number;
  picms: number;
  vicms: number;
  predbc: number;
  modbc: string;
  modbcst?: string;
  desconto: number;
  vseg: number;
  cstpis: string;
  picmsst: number;
  ppis: number;
  vipi: number;
  pipi: number;
  cstipi: string;
  vbcipi: number;
  vpis: number;
  vbcpis: number;
  cstcofins: string;
  vbccofins: number;
  pcofins: number;
  vcofins: number;
  bcicmsst: number;
  total: number;
  indtot: number;
  filtro: string;
  qtdglp?: number;
  // TAX do cadastro atual do produto (ver DetalheDeProduto.tsx) — quando
  // false, o item é ignorado ao gerar/enviar a nota pra SEFAZ (ver
  // GeraNfe.ts no backend), mesmo que o Ind. Total do item esteja marcado.
  // Só vem preenchido pelo getById (join com produtos).
  produtotax?: boolean;
}
interface IItensids {
  iditens: string;
}

const formValidationSchema: yup.ObjectSchema<Omit<IFormData, 'status' | 'serie'>> = yup.object().shape({
  nfe: yup.number().required(),
  indpag: yup.number().required(),
  tpnfe: yup.number().required(),
  natureza: yup.string().required(),
  dhemi: yup.string().required(),
  datasaida: yup.string().optional().default(''),
  tpemis: yup.number().required(),
  nfecpl: yup.string().optional().default(''),
  volumequantidade: yup.number().optional().default(0),
  volumemarca: yup.string().optional().default(''),
  volesp: yup.string().optional().default(''),
  volumepesobruto: yup.number().optional().default(0),
  volumepesoliquido: yup.number().optional().default(0),
  numerovolume: yup.string().optional().default(''),
  obscomplementar: yup.string().optional().default(''),
  tpag: yup.string().required(),
  finnfe: yup.number().required(),
  vbc: yup.number().required(),
  vicms: yup.number().required(),
  vprod: yup.number().required(),
  vfrete: yup.number().required(),
  vseg: yup.number().required(),
  vbcst: yup.number().required(),
  voutro: yup.number().required(),
  vdesc: yup.number().required(),
  vipi: yup.number().required(),
  vconfins: yup.number().required(),
  vpis: yup.number().required(),
  vst: yup.number().required(),
  vnfe: yup.number().required(),
  modfrete: yup.number().required(),
  idparceiro: yup.string().required(),
  idtransportadora: yup.string().nullable(),
  idveiculo: yup.string().nullable(),
});

export const DetalheDaNfe: React.FC = () => {
  const { id = 'novo' } = useParams<'id'>();
  const theme = useTheme();
  const navigate = useNavigate();
  const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const { isSaving, progress: saveProgress, iniciar: iniciarSalvamento, concluir: concluirSalvamento, cancelar: cancelarSalvamento } = useBloqueioSalvamento();
  const [open, setOpen] = useState(false);
  const [opencancelar, setOpencancelar] = useState(false);
  const [opencarta, setOpencarta] = useState(false);
  const [statuss, setStatuss] = useState(1);
  const [value, setValue] = useState('');
  const [valueCancelar, setValueCancelar] = useState('');
  const [valueCarta, setValuecarta] = useState('');
  const [iditens, setIditens] = useState('');
  const [transportadora, setTransportadora] = useState('');
  const [cfop, setCfop] = useState('');
  const [pdf, setPdf] = useState('');
  const [cancelar, setCancelar] = useState(1);
  const [rows, setRows] = useState<IItensNFe[]>([]);
  const [rowsids, setRowsids] = useState<IItensids[]>([]);
  const [dadositens, setDadositens] = useState<IItensNFe>();
  // Quantas vezes cada produto aparece em `rows` — usado só pra marcar na
  // tabela quais linhas são de um produto repetido (ver handleItens, que já
  // avisa no momento da inserção; isso aqui é o marcador visual permanente
  // na listagem, pros casos em que o aviso já foi fechado).
  const contagemPorProduto = useMemo(() => {
    const contagem = new Map<string, number>();
    rows.forEach((r) => {
      if (!r.idprodutos) return;
      contagem.set(r.idprodutos, (contagem.get(r.idprodutos) ?? 0) + 1);
    });
    return contagem;
  }, [rows]);
  const guuid = uuidv4();
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const [openConfirmItem, setOpenConfirmItem] = useState(false);
  const [iditem, setIditem] = useState('');
  // Verificação "a parte" (ver validarNotaFiscal.ts) — não interfere em nada
  // do fluxo de Salvar/Transmitir, só lê os dados já carregados na tela.
  const [openVerificar, setOpenVerificar] = useState(false);
  const [verificando, setVerificando] = useState(false);
  const [problemasNota, setProblemasNota] = useState<IProblemaNfe[]>([]);
  // Problema(s) do item aberto a partir de um clique em DialogVerificarNfe —
  // mostrado no header do DialoNfe (ver handleAbrirItemComInconsistencia).
  const [avisosItemAtual, setAvisosItemAtual] = useState<IProblemaNfe[]>([]);
  // Produto aberto pra correção a partir de um clique em DialogVerificarNfe —
  // null = dialog fechada (ver handleAbrirCadastroProduto).
  const [produtoParaCorrigir, setProdutoParaCorrigir] = useState<{ idprodutos: string; problemas: IProblemaNfe[] } | null>(null);
  // Controla se o Snackbar de sucesso deve voltar pra listagem ao fechar.
  // "Salvar" precisa manter o usuário na mesma nota (pra aparecer o botão
  // Transmitir); só "Salvar e Fechar" e as demais ações (ex.: Transmitir)
  // devem voltar — ver handleSave/handleTransmitir.
  const voltarAoFecharMsgRef = useRef(true);

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if (tms === 'success' && voltarAoFecharMsgRef.current) {
      navigate('/nfe');
    }
  };
  const handleDeleteItem = (idi: string) => {
    setOpenConfirmItem(true);
    setIditem(idi);
  };

  const handleCancelDeleteItem = () => {
    setOpenConfirmItem(false);
  };
  // Busca a nota já salva e repopula tela (form + itens) — usado no carregamento
  // inicial (ver useEffect abaixo) E depois de um "Salvar" bem-sucedido numa nota
  // já existente (ver handleSave), pra refletir dados que só vêm certos direto do
  // backend (ex.: NCM do item, que é puxado do cadastro ATUAL do produto via join,
  // não do que ficou em `rows` no navegador).
  const carregarNota = (idNota: string) => {
    setIsLoading(true);
    NfeService.getById(idNota)
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          // Notas antigas podem ter `natureza` gravada em minúsculo (bug já corrigido
          // nos dados do bancoteste, mas não em todo tenant) — as opções do select
          // (VENDA/COMPRA/...) só existem em maiúsculo, então um valor minúsculo não
          // casa com nenhum item e o campo aparece em branco. Normaliza aqui pra não
          // depender de corrigir cada banco de produção manualmente.
          formRef.current?.setData({
            ...result,
            natureza: result.natureza?.toUpperCase() ?? result.natureza,
          });
          setPdf(Environment.URL_PDFNFE);
          const itens = result.itens;
          const itensArray = Array.isArray(itens) ? itens : [itens];
          setRows(itensArray);
          setStatuss(result.status);
          const dataObjeto = new Date(result.dhemi);
          if (result.dhemi !== null) {
            const diferencaEmDias = calcularDiferencaEntreDatas(dataObjeto, new Date());
            if (diferencaEmDias > 24) {
              setCancelar(1);
            } else {
              setCancelar(2);
            }
          }
        }
      });
  };

  useEffect(() => {
    if (id !== 'novo') {
      carregarNota(id);
    } else {
      formRef.current?.setData({
        nfe: 1,
        indpag: 0,
        tpnfe: 1,
        natureza: 'VENDA',
        dhemi: dayjs().format('YYYY-MM-DD'),
        datasaida: dayjs().format('YYYY-MM-DD'),
        vbcst: 0,
        voutro: 0,
        tpemis: 1,
        nfecpl: '',
        volumequantidade: 0,
        volumemarca: '',
        volesp: '',
        volumepesobruto: 0,
        volumepesoliquido: 0,
        numerovolume: '',
        obscomplementar: '',
        tpag: '01',
        finnfe: 1,
        vbc: 0,
        vicms: 0,
        vprod: 0,
        vfrete: 0,
        vseg: 0,
        vdesc: 0,
        vst: 0,
        vipi: 0,
        vconfins: 0,
        vpis: 0,
        vnfe: 0,
        modfrete: 9,
        idparceiro: '',
        idtransportadora: null,
        idveiculo: null,
      });

    }
  }, [id]);

  function calcularDiferencaEntreDatas(data1: Date, data2: Date): number {
    const data1EmMilissegundos = data1.getTime();
    const data2EmMilissegundos = data2.getTime();
    const diferencaEmMilissegundos = Math.abs(data2EmMilissegundos - data1EmMilissegundos);
    const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60);
    return diferencaEmDias;
  }

  const handleSave = (dados: IFormData) => {
    if (!iniciarSalvamento()) return;

    formValidationSchema.
      validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        const operacao = id === 'novo'
          ? NfeService.create(dadosValidados, rows)
          : NfeService.updateById(id, dadosValidados, rows, rowsids);

        operacao.then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            cancelarSalvamento();
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setTms('success');
            setMsg(id === 'novo' ? 'Lançamento Realizado com sucesso!' : 'Alteração concluída com sucesso!');
            setOpenmsg(true);
            concluirSalvamento();

            if (isSaveAndClose()) {
              voltarAoFecharMsgRef.current = true;
            } else {
              // "Salvar" fica na mesma nota pra aparecer o botão Transmitir.
              voltarAoFecharMsgRef.current = false;
              if (id === 'novo' && typeof result === 'string') {
                // Rota real é /nfe/:id (ver routes/index.tsx) — não /nfe/detalhe/:id,
                // que não existe e cai no fallback "*", tirando o usuário da tela.
                navigate(`/nfe/${result}`, { replace: true });
              } else if (id !== 'novo') {
                // Atualização numa nota já existente: `id` não muda, então o
                // useEffect de carregamento (que só reage a mudança de `id`)
                // não dispara de novo sozinho — refaz o GET manualmente pra
                // tela refletir o que o backend realmente salvou (ex.: NCM do
                // item, que vem do cadastro ATUAL do produto via join, não do
                // que ficou em `rows` no navegador).
                carregarNota(id);
              }
            }
          }
        });
      })
      .catch((errors: yup.ValidationError) => {
        cancelarSalvamento();
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };

  const handleuuidtransportadora = (uuid: string | undefined) => {
    if (uuid != null) {
      setTransportadora(uuid);
    }
  };

  const handlecfop = (cfops: number | undefined) => {
    if (cfops != null) {
      if (cfops > 0) {
        setCfop(cfops.toString());
      }
    }
  };

  const handleClose = (newValue?: string) => {
    setOpen(false);
    setAvisosItemAtual([]);

    if (newValue) {
      setValue(newValue);
    }
  };

  const handleClosecancelar = (newValue?: string) => {
    setOpencancelar(false);

    if (newValue) {
      setValueCancelar(newValue);
    }
  };

  const handleClosecarta = (newValue?: string) => {
    setOpencarta(false);

    if (newValue) {
      setValuecarta(newValue);
    }
  };

  const toNumber = (v: unknown): number => {
    if (typeof v === 'number') {
      return v;
    }

    if (typeof v === 'string') {
      return Number(v.replace(/\./g, '').replace(',', '.')) || 0;
    }

    return 0;
  };


  const round4 = (v: number): number => {
    return Number(v.toFixed(4));
  };

  type RowsType = IItensNFe[];
  const calcularTotais = (lista: RowsType) => {
    // indtot === 0 ("Ind. Total" desmarcado) => valor do item não compõe o
    // total da nota (vProd/vNFe) — ver DialogNfe.tsx.
    const tvprod = round4(lista.reduce((acc, i) => acc + (i.indtot === 0 ? 0 : toNumber(i.total)), 0));
    const tbcicms = round4(lista.reduce((acc, i) => acc + toNumber(i.vbc), 0));
    const tvicms = round4(lista.reduce((acc, i) => acc + toNumber(i.vicms), 0));
    const tconfins = round4(lista.reduce((acc, i) => acc + toNumber(i.vcofins), 0));
    const tpis = round4(lista.reduce((acc, i) => acc + toNumber(i.vpis), 0));
    const tipi = round4(lista.reduce((acc, i) => acc + toNumber(i.vipi), 0));
    const tfrete = round4(lista.reduce((acc, i) => acc + toNumber(i.vfrete), 0));
    const tseguro = round4(lista.reduce((acc, i) => acc + toNumber(i.vseg), 0));
    const tdesconto = round4(lista.reduce((acc, i) => acc + toNumber(i.desconto), 0));
    const toutros = round4(lista.reduce((acc, i) => acc + toNumber(i.voutros), 0));
    const ticmsst = round4(lista.reduce((acc, i) => acc + toNumber(i.vicmsst), 0));  // ✅ Adicionado

    return {
      tvprod,
      tbcicms,
      tvicms,
      tconfins,
      tpis,
      tipi,
      tfrete,
      tseguro,
      tdesconto,
      toutros,
      ticmsst,  // ✅ Adicionado
    };
  };
  const handleItens = (dados: IItensNFe) => {
    console.log('dentro do handle itens', dados);

    const index = rows.findIndex((listItem) => listItem.iditens === dados.iditens);
    let updatedList: RowsType;

    // Só avisa, não bloqueia — o mesmo produto pode aparecer de propósito em
    // mais de uma linha (ex.: lotes/condições de venda diferentes).
    const jaExisteMesmoProduto = dados.idprodutos && rows.some(
      (listItem) => listItem.iditens !== dados.iditens && listItem.idprodutos === dados.idprodutos
    );
    if (jaExisteMesmoProduto) {
      setTms('warning');
      setMsg(`O item "${dados.descricao}" foi adicionado mais de uma vez nesta nota. Se foi de propósito, pode ignorar este aviso.`);
      setOpenmsg(true);
    }

    if (index !== -1) {
      updatedList = [...rows];
      updatedList[index] = dados;
    } else {
      // Item novo entra no topo da lista, não no final.
      updatedList = [dados, ...rows];
    }

    setRows(updatedList);
    const totais = calcularTotais(updatedList);

    // Calcular ICMS-ST a partir da lista completa, não do item individual
    const totalIcmsSt = round4(updatedList.reduce((acc, i) => acc + toNumber(i.vicmsst), 0));

    // Calcular o valor total da nota conforme a fórmula correta:
    // Valor Total = (Valor dos Produtos + Frete + Seguro + Outras Despesas + IPI + ICMS-ST) - Descontos
    const tnfe = round4(
      totais.tvprod +      // Valor dos produtos
      totais.tfrete +      // Frete
      totais.tseguro +     // Seguro
      totais.tipi +        // IPI
      // PIS/COFINS NÃO entram no vNF (já estão no preço) — somar aqui fazia o
      // total gravado (relatórios/listagem) ficar maior que o autorizado.
      totalIcmsSt +        // ICMS-ST (corrigido)
      totais.toutros -     // Outras despesas
      totais.tdesconto     // Descontos
    );

    // Atualizar todos os campos do formulário
    Object.entries(totais).forEach(([campo, valor]) => {
      formRef.current?.setFieldValue(campo, valor);
    });

    formRef.current?.setFieldValue('vnfe', tnfe);
    formRef.current?.setFieldValue('vprod', totais.tvprod);
    formRef.current?.setFieldValue('vconfins', totais.tconfins);
    formRef.current?.setFieldValue('vpis', totais.tpis);
    formRef.current?.setFieldValue('vipi', totais.tipi);
    formRef.current?.setFieldValue('vfrete', totais.tfrete);
    formRef.current?.setFieldValue('vseg', totais.tseguro);
    formRef.current?.setFieldValue('voutro', totais.toutros);
    formRef.current?.setFieldValue('vdesc', totais.tdesconto);
    formRef.current?.setFieldValue('vicms', totais.tvicms);
    formRef.current?.setFieldValue('vbc', totais.tbcicms);
    formRef.current?.setFieldValue('vst', totalIcmsSt);  // Adicionar campo vst
  };
  const handlePrint = () => {
    setIsLoading(true);
    NfeService.Imprimir(id)
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          const blob = new Blob([result], { type: 'application/pdf' });
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
          setTimeout(() => URL.revokeObjectURL(url), 10000);
        }
      });
  };
  const handleConfirmDeleteItem = () => {
    let meuObjeto = { iditens: iditem };
    rowsids.push(meuObjeto);

    const indexToDelete = rows.findIndex((item) => item.iditens === iditem);
    if (indexToDelete !== -1) {
      const updatedList = [...rows];
      updatedList.splice(indexToDelete, 1);
      setRows(updatedList);
      const totais = calcularTotais(updatedList);
      const totalIcmsSt = round4(updatedList.reduce((acc, i) => acc + toNumber(i.vicmsst), 0));
      const tnfe = round4(
        totais.tvprod +     
        totais.tfrete +    
        totais.tseguro +    
        totais.tipi +        // PIS/COFINS não entram no vNF
        totalIcmsSt +        
        totais.toutros -     
        totais.tdesconto     
      );
      formRef.current?.setFieldValue('vprod', totais.tvprod);
      formRef.current?.setFieldValue('vbc', totais.tbcicms);
      formRef.current?.setFieldValue('vicms', totais.tvicms);
      formRef.current?.setFieldValue('vconfins', totais.tconfins);
      formRef.current?.setFieldValue('vpis', totais.tpis);
      formRef.current?.setFieldValue('vipi', totais.tipi);
      formRef.current?.setFieldValue('vfrete', totais.tfrete);
      formRef.current?.setFieldValue('vseg', totais.tseguro);
      formRef.current?.setFieldValue('vdesc', totais.tdesconto);
      formRef.current?.setFieldValue('voutro', totais.toutros);
      formRef.current?.setFieldValue('vst', totalIcmsSt);
      formRef.current?.setFieldValue('vnfe', tnfe);
    }

    setOpenConfirmItem(false);
  };

  const handleTransmitir = () => {
    setIsLoading(true);
    voltarAoFecharMsgRef.current = true;

    // Passa os itens pra traduzirErroFiscal tentar mapear QUAL item tem o
    // problema (cruza NCM/CFOP/EAN/CST citado no erro, ou o número do item
    // quando a rejeição da SEFAZ cita um) — ver traduzirErroFiscal.ts.
    NfeService.transmitir(id, rows)
      .then((result) => {
        setIsLoading(false);

        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
          return;
        }
        const blob = result;
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 10000);
        setTms('success');
        setMsg('Transmitido Realizado com sucesso!');
        setOpenmsg(true);
      });
  };

  // Verificação "a parte" — busca o regime tributário da empresa (crt) e
  // roda as regras de validarNotaFiscal.ts contra os itens já lançados na
  // tela + o cadastro atual de cada produto. Não altera `rows` nem chama
  // NfeService.transmitir — só informa (ver DialogVerificarNfe.tsx).
  const handleVerificarNota = async () => {
    setOpenVerificar(true);
    setVerificando(true);
    setProblemasNota([]);
    try {
      const dadosCabecalho = formRef.current?.getData() as Partial<IFormData> | undefined;
      // Mesma fonte de crt usada em DialogNfe.tsx (JWT em cache, sem
      // chamada de rede) — 1/2 = Simples Nacional (CSOSN), 3 = Regime
      // Normal (CST).
      const crt = getAuth()?.crt ?? null;

      const problemas = await verificarNotaFiscalAntesDeEnviar(
        {
          idparceiro: dadosCabecalho?.idparceiro || '',
          tpnfe: Number(dadosCabecalho?.tpnfe ?? 1),
          modfrete: Number(dadosCabecalho?.modfrete ?? 9),
          idtransportadora: dadosCabecalho?.idtransportadora,
          // Totais do cabeçalho (já recalculados pelo handleItens a cada item
          // adicionado/removido) — comparados contra a soma dos itens (ver
          // validarTotaisNota em validarNotaFiscal.ts).
          vprod: Number(dadosCabecalho?.vprod),
          vicms: Number(dadosCabecalho?.vicms),
          vpis: Number(dadosCabecalho?.vpis),
          vconfins: Number(dadosCabecalho?.vconfins),
          vfrete: Number(dadosCabecalho?.vfrete),
          vdesc: Number(dadosCabecalho?.vdesc),
          // Textos do cabeçalho que vão pro XML (ver verificarTextos).
          natureza: dadosCabecalho?.natureza,
          nfecpl: dadosCabecalho?.nfecpl,
          obscomplementar: dadosCabecalho?.obscomplementar,
        },
        rows,
        crt,
      );
      setProblemasNota(problemas);
    } catch {
      setProblemasNota([{ severidade: 'erro', campo: 'Verificação', mensagem: 'Não foi possível concluir a verificação. Tente novamente.' }]);
    } finally {
      setVerificando(false);
    }
  };

  // Clique num problema de item dentro de DialogVerificarNfe — abre o mesmo
  // dialog de edição de item já usado no ícone de lápis da tabela, só que com
  // o(s) problema(s) encontrados marcados no header (ver DialogNfe.tsx).
  const handleAbrirItemComInconsistencia = (iditens: string, problemasDoItem: IProblemaNfe[]) => {
    const item = rows.find((row) => row.iditens === iditens);
    if (!item) return; // item pode ter sido removido depois da verificação

    setOpenVerificar(false);
    setIditens(item.iditens);
    setDadositens(item);
    setAvisosItemAtual(problemasDoItem);
    setOpen(true);
  };

  // Clique num problema de cadastro de produto dentro de DialogVerificarNfe —
  // abre o cadastro COMPLETO do produto (mesma tela de sempre) numa dialog,
  // com a inconsistência marcada no topo (ver DetalheDeProduto.tsx/modoDialog).
  const handleAbrirCadastroProduto = (idprodutos: string, problemasDoProduto: IProblemaNfe[]) => {
    setOpenVerificar(false);
    setProdutoParaCorrigir({ idprodutos, problemas: problemasDoProduto });
  };

  const handleDownloadXml = () => {
    setIsLoading(true);
    NfeService.baixarXml(id)
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          const blob = new Blob([result], { type: 'application/xml' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `nfe_${id}.xml`;
          link.click();
          setTimeout(() => URL.revokeObjectURL(url), 10000);
        }
      });
  };

  const handleCancelar = () => {
    setOpencancelar(true);
  };

  const handleCarta = () => {
    setOpencarta(true);
  };

  return (
    <>
      <TelaBloqueioSalvando
        open={isSaving}
        message={id === 'novo' ? 'Salvando nova nota fiscal...' : 'Salvando alterações...'}
        progress={saveProgress}
      />
      <LayoutBaseDePaginaNfe
      barraDeFerramentas={
        <FerramentasDeDetalheNfe
          textoBotaoNovo='Novo'
          mostrarBotaoSalvarEFechar={false}
          mostrarBotaoNovo={id !== 'novo'}
          mostrarBotaoApagar={false}
          mostrarBotaoImpressao={id !== 'novo'}
          mostrarBotaoCancelar={id !== 'novo' || statuss !== 1}
          mostrarBotaoCarta={id !== 'novo'}
          mostrarBotaoProtocolo={false}
          mostrarBotaoTransmitir={id !== 'novo'}
          mostrarBotaoVerificar={id !== 'novo'}
          mostrarBotaoXml={id !== 'novo'}
          mostrarBotaoApagarCarregando={false}
          mostrarBotaoImpressaoCarregando={isLoading}
          disableBotaoSalvar={statuss === 1 ? (isLoading || isSaving) : true}
          disableBotaoImpressao={statuss === 2 ? isLoading : true}
          disableBotaoCancelar={statuss === 2 ? isLoading : true}
          disableBotaoTransmitir={statuss === 1 ? isLoading : true}
          disableBotaoVerificar={statuss === 1 ? (isLoading || verificando) : true}
          disableBotaoSalvarEFechar={statuss === 1 ? (isLoading || isSaving) : true}
          disableBotaoCarta={statuss === 2 ? isLoading : true}
          disableBotaoXml={statuss === 2 ? isLoading : true}
          aoClicarEmSalvar={save}
          aoClicarEmSalvarEFechar={saveAndClose}
          aoClicarEmTransmitir={handleTransmitir}
          aoClicarEmVerificar={handleVerificarNota}
          aoClicarEmCancelar={handleCancelar}
          aoClicarEmCarta={handleCarta}
          aoClicarEmXml={handleDownloadXml}
          aoClicarEmVoltar={() => navigate('/nfe')}
          mostrarBotaoVoltarCarregando={isLoading}
          mostrarBotaoTransmitirCarregando={isLoading}
          aoClicarEmNovo={() => navigate('/nfe/novo')}
          aoClicarEmImpressao={() => handlePrint()}
          mostrarBotaoNovoCarregando={isLoading}
        />
      }
    >
      <VForm ref={formRef} onSubmit={handleSave} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        {/* Erro (ex.: rejeição da SEFAZ ao transmitir, ver traduzirErroFiscal) fica
            aberto até o usuário fechar — a mensagem pode ter várias linhas, e um
            auto-hide de 900ms não dá tempo de ler. */}
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={tms === 'success' ? 900 : null} onClose={handleCloseMsg}>
          <Alert
            onClose={handleCloseMsg}
            severity={tms}
            variant="filled"
            sx={{ width: '100%', whiteSpace: 'pre-line' }}
          >
            {msg}
          </Alert>
        </Snackbar>
        <Snackbar open={openConfirmItem} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert
            severity="warning"
            variant="filled"
            sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
            action={
              <>
                <Button color="inherit" size="small" onClick={handleConfirmDeleteItem}>
                  Sim
                </Button>
                <Button color="inherit" size="small" onClick={handleCancelDeleteItem}>
                  Nâo
                </Button>
              </>
            }
          >
            Tem certeza que deseja excluir este Item?
          </Alert>
        </Snackbar>
        <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
          <Grid container direction="column" padding={1} spacing={1}>
            {isLoading && (
              <Grid item>
                <LinearProgress variant='indeterminate' />
              </Grid>
            )}
            <Grid container item direction="row" spacing={2}>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item direction="row" spacing={2} >
                  <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                    <AutoCompleteParceiro
                      isExternalLoading={statuss === 1 ? isLoading : true}
                      cfops={handlecfop}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={4} lg={2} xl={2}>
                    <BasicSelect
                      name='natureza'
                      label='Natureza'
                      data={[
                        { nameBD: 'VENDA', descricao: 'Venda' },
                        { nameBD: 'COMPRA', descricao: 'Compra' },
                        { nameBD: 'TRANSFERENCIA', descricao: 'Transferência' },
                        { nameBD: 'DEVOLUCAO', descricao: 'Devolução' },
                        { nameBD: 'IMPORTACAO', descricao: 'Importação' },
                        { nameBD: 'REMESSA', descricao: 'Remessa (Garantia, conserto, demonstração, industrialização, brindes)'},
                        { nameBD: 'REMESSA DE VASILHAME', descricao: 'Remessa de Vasilhame'},
                        { nameBD: 'DEVOLUCAO DE COMPRA DE COMBUSTIVEIS', descricao: 'Devolução de Compra De Combustíveis'},
                      ]}
                      disabled={statuss !== 1 || isLoading}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <BasicSelect
                      name='tpemis'
                      label='Tipo Emissão'
                      data={[
                        { nameBD: '1', descricao: 'Emissão normal' },
                        { nameBD: '2', descricao: 'Contingência FS-IA' },
                        { nameBD: '7', descricao: 'Contingência SVC-RS' },
                      ]}
                      disabled={statuss !== 1 || isLoading}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={3} lg={2} xl={2}>
                    <VTextFieldData
                      fullWidth
                      name='dhemi'
                      label='Data Emissão'
                      disabled={statuss !== 1 || isLoading}
                    />
                  </Grid>

                  <Grid item xs={6} sm={6} md={3} lg={2} xl={2}>
                    <VTextFieldData
                      fullWidth
                      name='datasaida'
                      label='Data Saida'
                      disabled={statuss !== 1 || isLoading}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item direction="row" spacing={2} >

                  <Grid item xs={6} sm={6} md={2} lg={2} xl={1}>
                    <BasicSelectNumber
                      name='tpnfe'
                      label='Tipo'
                      data={[
                        { nameBD: 0, descricao: 'Entrada' },
                        { nameBD: 1, descricao: 'Saida' },
                      ]}
                      disabled={statuss !== 1 || isLoading}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={1}>
                    <VTextField
                      fullWidth
                      size='small'
                      name='nfe'
                      label='Numero'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <BasicSelectNumber
                      name='finnfe'
                      label='Finalidade'
                      data={[
                        { nameBD: 1, descricao: 'NF-e normal' },
                        { nameBD: 2, descricao: 'NF-e complementar' },
                        { nameBD: 3, descricao: 'NF-e de ajuste' },
                        { nameBD: 4, descricao: 'Devolução de mercadoria' },
                      ]}
                      disabled={statuss === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <BasicSelectNumber
                      name='indpag'
                      label='Pagamento'
                      data={[
                        { nameBD: 0, descricao: 'Vista' },
                        { nameBD: 1, descricao: 'Prazo' },
                        { nameBD: 2, descricao: 'Outros' },
                      ]}
                      disabled={statuss === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <BasicAutoComplete
                      name='tpag'
                      label='Tipo Pagamento'
                      data={[
                        { nameBD: '01', descricao: 'Dinheiro' },
                        { nameBD: '02', descricao: 'Cheque' },
                        { nameBD: '03', descricao: 'Cartao Credito' },
                        { nameBD: '04', descricao: 'Cartao Debito' },
                        { nameBD: '05', descricao: 'Credito Loja' },
                        { nameBD: '10', descricao: 'Vale Alimentacao' },
                        { nameBD: '11', descricao: 'Vale Refeicao' },
                        { nameBD: '12', descricao: 'Vale Presente' },
                        { nameBD: '13', descricao: 'Vale Combustivel' },
                        { nameBD: '15', descricao: 'Boleto Bancario' },
                        { nameBD: '16', descricao: 'Deposito Bancario' },
                        { nameBD: '17', descricao: 'Pagamento Instantaneo(PIX)-Dinâmico (PIX realizado a geração do Qr-Code de forma dinâmica ou URL dinâmica' },
                        { nameBD: '18', descricao: 'Transferência Bancario' },
                        { nameBD: '19', descricao: 'Programa Fidelidade' },
                        { nameBD: '20', descricao: 'Pagamento Instantaneo(PIX)-Estático (PIX realizado com Qr-Code estático ou por meio de transferência' },
                        { nameBD: '21', descricao: 'Crédito em Loja' },
                        { nameBD: '22', descricao: 'Pagamento Eletrônico não informado - falha de hardware do sistema emissor' },
                        { nameBD: '90', descricao: 'Sem Pagamento' },
                        { nameBD: '99', descricao: 'Outro' },
                      ]}
                      disabled={statuss === 1 ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='vbc'
                      label='Base C. ICMS'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='vst'
                      label='valor substituicao tribut'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='vicms'
                      label='Valor ICMS'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='vconfins'
                      label='COFINS'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1} xl={1}>
                    <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='vpis'
                      label='PIS'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1} xl={1}>
                    <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='vipi'
                      label='Valor IPI'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='vfrete'
                      label='Valor Frete'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='vseg'
                      label='Valor Seguro'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='vdesc'
                      label='desconto'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={2} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='vprod'
                      label='Valor dos Produtos'
                      disabled={true}
                    />
                  </Grid>

                  <Grid item xs={6} sm={2} md={2} lg={2} xl={2}>
                    <BasicSelectNumber
                      name='modfrete'
                      label='Tipo Frete'
                      data={[
                        { nameBD: 0, descricao: 'Conta Emitente' },
                        { nameBD: 1, descricao: 'Conta Destinatario' },
                        { nameBD: 2, descricao: 'Conta Terceiros' },
                        { nameBD: 3, descricao: 'Proprio Remetente' },
                        { nameBD: 4, descricao: 'Proprio Destinatario' },
                        { nameBD: 9, descricao: 'Sem Frete' },
                      ]}
                      disabled={statuss !== 1 || isLoading}
                    />
                  </Grid>
                  <Grid item xs={6} sm={2} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='vnfe'
                      label='Valor Nota'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={3} md={2} lg={2} xl={2}>
                    <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='vbcst'
                      label='BaseC. Sub Tributaria'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={3} md={2} lg={2} xl={4}>
                    <VFieldMoneyNumber4dn
                      fullWidth
                      size='small'
                      name='voutro'
                      label='Valor Outro'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    <AutoCompleteTransportadora
                      isExternalLoading={statuss === 1 ? isLoading : true}
                      uuidtransportadora={handleuuidtransportadora}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={6} xl={6}>
                    <AutoCompleteVeiculos
                      isExternalLoading={statuss === 1 ? isLoading : true}
                      idtransportadora={transportadora}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TableContainer
                  component={Paper}
                  elevation={0}
                  sx={{
                    width: '100%',
                    minHeight: 350,
                    maxHeight: 350,
                    overflow: 'auto',

                    borderRadius: 3,
                    border: 'none',
                    backgroundColor: 'transparent',
                    scrollbarWidth: 'thin',
                    scrollbarColor: `${alpha(theme.palette.text.primary, 0.35)} transparent`,

                    '&::-webkit-scrollbar': {
                      width: 8,
                      height: 8,
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: alpha(theme.palette.text.primary, 0.35),
                      borderRadius: 8,
                    },
                  }}
                >
                  <Table
                    size="small"
                    stickyHeader
                    sx={{
                      width: '100%',
                      borderCollapse: 'separate',
                      borderSpacing: '0 10px',
                    }}
                  >
                    <TableHead>
                      <TableRow
                        sx={{
                          '& th': {
                            fontSize: '0.78rem',
                            fontWeight: 700,
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em',
                            backgroundColor:
                              theme.palette.mode === 'dark'
                                ? alpha(theme.palette.grey[900], 0.95)
                                : alpha(theme.palette.primary.main, 0.08),
                            color:
                              theme.palette.mode === 'dark'
                                ? theme.palette.grey[100]
                                : theme.palette.grey[800],
                            border: 'none',
                            py: 1.2,
                          },
                        }}
                      >
                        <TableCell sx={{ width: 300 }}>Descrição</TableCell>
                        <TableCell align="center">NCM</TableCell>
                        <TableCell align="center">CST</TableCell>
                        <TableCell align="center">CFOP</TableCell>
                        <TableCell align="center">UN</TableCell>
                        <TableCell align="right">QTD</TableCell>
                        <TableCell align="right">V.UN</TableCell>
                        <TableCell align="right">Desc</TableCell>
                        <TableCell align="right">Total</TableCell>
                        <TableCell align="right">B.C ICMS</TableCell>
                        <TableCell align="right">V. ICMS</TableCell>
                        <TableCell align="right">Aliq. ICMS</TableCell>
                        <TableCell align="center">
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => {
                              setIditens('novo');
                              setAvisosItemAtual([]);
                              setOpen(true);
                            }}
                            sx={{
                              bgcolor: alpha(theme.palette.primary.main, 0.15),
                              '&:hover': {
                                bgcolor: alpha(theme.palette.primary.main, 0.3),
                              },
                            }}
                          >
                            <AddShoppingCartIcon fontSize="small" />
                          </IconButton>
                        </TableCell>

                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.length === 0 ? (
                        <TableRow>
                          <TableCell
                            colSpan={12}
                            align="center"
                            sx={{ py: 6, color: 'text.secondary', fontStyle: 'italic' }}
                          >
                            Nenhum item adicionado.
                          </TableCell>
                        </TableRow>
                      ) : (
                        rows.map(row => {
                          const vezesRepetido = row.idprodutos ? contagemPorProduto.get(row.idprodutos) ?? 0 : 0;
                          const duplicado = vezesRepetido > 1;
                          // Ind. Total desmarcado => valor deste item não soma no total da nota.
                          const indTotDesmarcado = row.indtot === 0;
                          // TAX desmarcado no cadastro do produto => item é ignorado ao enviar
                          // a nota pra SEFAZ (ver GeraNfe.ts), independente do Ind. Total.
                          const produtoTaxDesmarcado = row.produtotax === false;
                          const naoSomaTotal = indTotDesmarcado || produtoTaxDesmarcado;
                          let avisoNaoSoma = '';
                          if (indTotDesmarcado && produtoTaxDesmarcado) {
                            avisoNaoSoma = 'Ind. Total desmarcado e produto com TAX desmarcado no cadastro: este item não soma no total da nota e será ignorado ao enviar para a SEFAZ';
                          } else if (produtoTaxDesmarcado) {
                            avisoNaoSoma = 'Produto com TAX desmarcado no cadastro: este item será ignorado ao enviar a nota para a SEFAZ e não soma no total';
                          } else if (indTotDesmarcado) {
                            avisoNaoSoma = 'Ind. Total desmarcado: o valor deste item não soma no total da nota';
                          }
                          return (
                          <TableRow
                            key={row.iditens}
                            hover
                            sx={{
                              transition: 'all 0.2s ease',

                              '&:hover': {
                                transform: 'translateY(-2px)',
                                '& td': {
                                  backgroundColor: alpha(theme.palette.primary.main, 0.12),
                                },
                              },

                              '& td': {
                                py: 1.1,
                                fontSize: '0.8rem',
                                backgroundColor: naoSomaTotal
                                  ? alpha(theme.palette.grey[500], theme.palette.mode === 'dark' ? 0.24 : 0.16)
                                  : duplicado
                                    ? alpha(theme.palette.warning.main, theme.palette.mode === 'dark' ? 0.18 : 0.12)
                                    : (theme.palette.mode === 'dark'
                                      ? alpha(theme.palette.grey[900], 0.6)
                                      : theme.palette.common.white),
                                color: naoSomaTotal ? theme.palette.text.secondary : undefined,
                                border: 'none',
                              },

                              '& td:first-of-type': {
                                borderTopLeftRadius: 16,
                                borderBottomLeftRadius: 16,
                              },

                              '& td:last-of-type': {
                                borderTopRightRadius: 16,
                                borderBottomRightRadius: 16,
                              },
                            }}
                          >
                            <TableCell sx={{ width: 300 }}>
                              <Box display="flex" flexDirection="column" gap={0.3}>
                                <Box display="flex" alignItems="center" gap={0.5}>
                                  {duplicado && (
                                    <Tooltip title={`Este produto aparece ${vezesRepetido} vezes nesta nota`} arrow>
                                      <Icon fontSize="small" sx={{ color: theme.palette.warning.dark }}>content_copy</Icon>
                                    </Tooltip>
                                  )}
                                  {naoSomaTotal && (
                                    <Tooltip title={avisoNaoSoma} arrow>
                                      <Icon fontSize="small" sx={{ color: produtoTaxDesmarcado ? theme.palette.error.dark : theme.palette.text.secondary }}>money_off</Icon>
                                    </Tooltip>
                                  )}
                                  <span>{row.descricao}</span>
                                </Box>
                                {naoSomaTotal && (
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: produtoTaxDesmarcado ? theme.palette.error.dark : theme.palette.text.secondary,
                                      lineHeight: 1.2,
                                    }}
                                  >
                                    {avisoNaoSoma}
                                  </Typography>
                                )}
                              </Box>
                            </TableCell>
                            <TableCell align="center">{row.ncm}</TableCell>
                            <TableCell align="center">{row.cst}</TableCell>
                            <TableCell align="center">{row.cfop}</TableCell>
                            <TableCell align="center">{row.un}</TableCell>
                            <TableCell align="right">
                              {row.qtd.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                            </TableCell>
                            <TableCell align="right">
                              {row.preco.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 4,
                              })}
                            </TableCell>
                            <TableCell align="right">
                              {row.desconto.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 4,
                              })}
                            </TableCell>
                            <TableCell align="right" sx={naoSomaTotal ? { textDecoration: 'line-through' } : undefined}>
                              {row.total.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 4,
                              })}
                            </TableCell>
                            <TableCell align="right">
                              {row.vbc.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 4,
                              })}
                            </TableCell>
                            <TableCell align="right">
                              {row.vicms.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 4,
                              })}
                            </TableCell>
                            <TableCell align="right">
                              {row.picms.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 4,
                              })}
                            </TableCell>
                            <TableCell align="center">
                              <Box display="flex" justifyContent="center" gap={0.5}>

                                <IconButton
                                  size="small"
                                  color="primary"
                                  onClick={() => {
                                    setIditens(row.iditens);
                                    setDadositens(row);
                                    setAvisosItemAtual([]);
                                    setOpen(true);
                                  }}
                                  sx={{
                                    bgcolor: alpha(theme.palette.primary.main, 0.15),
                                    '&:hover': {
                                      bgcolor: alpha(theme.palette.primary.main, 0.3),
                                    },
                                  }}
                                >
                                  <Icon fontSize="small">edit</Icon>
                                </IconButton>
                                <IconButton
                                  size="small"
                                  color="error"
                                  onClick={() => handleDeleteItem(row.iditens)}
                                  sx={{
                                    bgcolor: alpha(theme.palette.error.main, 0.15),
                                    '&:hover': {
                                      bgcolor: alpha(theme.palette.error.main, 0.3),
                                    },
                                  }}
                                >
                                  <Icon fontSize="small">delete</Icon>
                                </IconButton>
                              </Box>
                            </TableCell>
                          </TableRow>
                          );
                        })
                      )}
                    </TableBody>

                  </Table>
                </TableContainer>

              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item direction="row" spacing={2} >
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <VTextField
                      fullWidth
                      name='obscomplementar'
                      label='Informaçoes Adicionais'
                      multiline
                      rows={3}
                      disabled={statuss === 1 ? isLoading : true}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <Grid container item direction="row" spacing={2} >
                      <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                        <VTextFieldNumber
                          fullWidth
                          size='small'
                          name='volumequantidade'
                          label='Quantidade'
                          disabled={statuss === 1 ? isLoading : true}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                        <VTextField
                          fullWidth
                          size='small'
                          name='volesp'
                          label='Espécie'
                          disabled={statuss === 1 ? isLoading : true}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                        <VTextField
                          fullWidth
                          size='small'
                          name='numerovolume'
                          label='Numero Volume'
                          disabled={statuss === 1 ? isLoading : true}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                        <VTextField
                          fullWidth
                          size='small'
                          name='volumemarca'
                          label='Marca'
                          disabled={statuss === 1 ? isLoading : true}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                        <VTextField
                          fullWidth
                          size='small'
                          name='volumepesobruto'
                          label='Peso Bruto'
                          disabled={statuss === 1 ? isLoading : true}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                        <VTextField
                          fullWidth
                          size='small'
                          name='volumepesoliquido'
                          label='Peso Liquido'
                          disabled={statuss === 1 ? isLoading : true}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <VTextField
                          size='small'
                          fullWidth
                          name='nfecpl'
                          label='Chave da Nota Referenciada'
                          disabled={statuss === 1 ? isLoading : true}
                        />
                      </Grid>

                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <DialoNfe
              id={iditens}
              value={guuid}
              cfop={Number(cfop)}
              dados={dadositens}
              open={open}
              onDados={handleItens}
              onClose={handleClose}
              status={statuss}
              problemasParaCorrigir={avisosItemAtual}
            />
            <DialoCancelar
              id={id}
              open={opencancelar}
              onClose={handleClosecancelar}
              status={statuss}
            />
            <DialogCartaCorrecao
              id={id}
              open={opencarta}
              onClose={handleClosecarta}
              status={statuss}
            />
            <DialogVerificarNfe
              open={openVerificar}
              carregando={verificando}
              problemas={problemasNota}
              onClose={() => setOpenVerificar(false)}
              onAbrirItem={handleAbrirItemComInconsistencia}
              onAbrirProduto={handleAbrirCadastroProduto}
            />
            {produtoParaCorrigir && (
              <DetalheDeProduto
                idEmbutido={produtoParaCorrigir.idprodutos}
                modoDialog={{
                  onFechar: () => setProdutoParaCorrigir(null),
                  problemas: produtoParaCorrigir.problemas,
                }}
              />
            )}
          </Grid>
        </Box>
      </VForm>

      </LayoutBaseDePaginaNfe>
    </>
  );
};